import { useState } from 'react';
import { ApiResponse_string, MemberFirearmClient, MemberFirearmDTO } from '../services/apiClient';
import { API_BASE_URL } from '../config/config';
import axiosInstance from '../services/axiosInstance';

export const useMemberFirearmApi = () => {
    const apiClient = new MemberFirearmClient(API_BASE_URL, axiosInstance);

    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);

    const create = async (data: MemberFirearmDTO) => {
        setIsLoading(true);
        try {
            await apiClient.createMemberFirearm(data);
        } catch (err: any) {
            setError(err.message || 'Error creating MemberFirearm');
        } finally {
            setIsLoading(false);
        }
    };

    const edit = async (id: string, data: MemberFirearmDTO) => {
        setIsLoading(true);
        try {
            await apiClient.updateMemberFirearm(id, data);
        } catch (err: any) {
            setError(err.message || 'Error updating MemberFirearm');
        } finally {
            setIsLoading(false);
        }
    };

    const getById = async (id: string) => {
        setIsLoading(true);
        try {
            return await apiClient.getMemberFirearmById(id);
        } catch (err: any) {
            setError(err.message || 'Error fetching MemberFirearm');
        } finally {
            setIsLoading(false);
        }
    };

    const search = async (filters: any) => {
        setIsLoading(true);
        try {
            return await apiClient.searchMemberFirearms(filters);
        } catch (err: any) {
            setError(err.message || 'Error searching MemberFirearms');
        } finally {
            setIsLoading(false);
        }
    };

    const remove = async (id: string) => {
        setIsLoading(true);
        try {
            await apiClient.deleteMemberFirearm(id);
        } catch (err: any) {
            setError(err.message || 'Error deleting MemberFirearm');
        } finally {
            setIsLoading(false);
        }
    };

    const extract = async (
    filters: any,
  ): Promise<ApiResponse_string> => {
    setIsLoading(true);
    try {
      return await apiClient.exportMemberFireamrs(filters);
    } catch (err: unknown) {
      throw err;
    } finally {
      setIsLoading(false);
    }
  };

    return { create, edit, getById, search, remove, extract, isLoading, error };
};